'use strict';

angular.module('schoolbushubApp').controller('NotificationAuditDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'NotificationAudit', 'VehicleAudit',
        function($scope, $stateParams, $uibModalInstance, entity, NotificationAudit, VehicleAudit) {

        $scope.notificationAudit = entity;
        $scope.vehicleaudits = VehicleAudit.query();
        $scope.load = function(id) {
            NotificationAudit.get({id : id}, function(result) {
                $scope.notificationAudit = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('schoolbushubApp:notificationAuditUpdate', result);
            $uibModalInstance.close(result);
            $scope.isSaving = false;
        };

        var onSaveError = function (result) {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.isSaving = true;
            if ($scope.notificationAudit.id != null) {
                NotificationAudit.update($scope.notificationAudit, onSaveSuccess, onSaveError);
            } else {
                NotificationAudit.save($scope.notificationAudit, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.datePickerForDate = {};

        $scope.datePickerForDate.status = {
            opened: false
        };

        $scope.datePickerForDateOpen = function($event) {
            $scope.datePickerForDate.status.opened = true;
        };
}]);
